import React from "react";
import Typography from '@material-ui/core/Typography';

export default ({level, show, className, children, paragraph, component}) => show ? <div className={`message message--${level} ${className || ''}`}>
	<Typography variant="subtitle1" component={component || 'div'} paragraph={paragraph}>{children}</Typography>
</div> : null;
